import api from './api'

console.log('🔧 SettingsService initialized');

export const settingsService = {
  async getFinancialSettings() {
    try {
      console.log('📡 Fetching financial settings...')
      const response = await api.get('/settings/financial')
      console.log('✅ Financial settings received:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Error fetching financial settings:', error)
      throw error
    }
  },

  async updateFinancialSettings(data) {
    try {
      console.log('📡 Updating financial settings...', data)
      const response = await api.put('/settings/financial', data)
      console.log('✅ Financial settings updated:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Error updating financial settings:', error)
      throw error
    }
  },

  // System Messages
  async getSystemMessage(type) {
    try {
      console.log('📡 Fetching system message...', type)
      const response = await api.get(`/settings/system-messages/${type}`)
      console.log('✅ System message received:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Error fetching system message:', error)
      throw error
    }
  },

  async getAllSystemMessages() {
    try {
      console.log('📡 Fetching all system messages...')
      const response = await api.get('/settings/system-messages')
      console.log('✅ System messages received:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Error fetching system messages:', error)
      throw error
    }
  },

  async updateSystemMessage(type, data) {
    try {
      console.log('📡 Updating system message...', type, data)
      const response = await api.put(`/settings/system-messages/${type}`, data)
      console.log('✅ System message updated:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Error updating system message:', error)
      throw error
    }
  }
}

